module.exports = __webpack_public_path__ + "img/Autocolant TCLH_150mm x 180mm-01.687eeae0.jpg";